import { Debug } from "@ctra/utils";

import { default as reducer, initialState } from "./reducer";
import * as utils from "./utils";

Debug.create("eventApi", "Timeline Events API", { prefixColor: "#661111", transports: true });

export { default as types } from "./types";
export { default as schemas } from "./schemas";
export { default as actions } from "./actions";
export { default as epics } from "./epics";
export { reducer, initialState };

export * from "./typings";
export * from "./schemas";
export { utils };

export default reducer;
